import PreCandidateProvider from "../context/Context";
import MassImport from "./MassImport";

export default function MasssImportPage() {
  return (
    <PreCandidateProvider>
      <MassImport />
    </PreCandidateProvider>
  );
}
